import { 
    alertMessages, 
    getCalcResultsQuery, 
    getWeatherRelatedNFDRSQuery
} from "src/constants";
import { configMutationClimatology } from "./mutationsApiKey";
import { errorResponse } from "src/store/common";
import axios from "axios";

/*will return the results from the calculator*/
export const getCalcResultsCall = async(request: any, addAlert:any,) => {
  try {
    let data = JSON.stringify({
      query: getCalcResultsQuery,
      variables: {
        stationId: request.stationId,
        windSpeed: request.windSpeed,
        temperature: request.temperature,
        solarRadiation: request.solarRadiation,
        relativeHumidity: request.relativeHumidity,
        precipitation: request.precipitation,
        snowFlag: request.snowFlag,
        fuelModel: request.fuelModel,
      }
    });
    let config = configMutationClimatology(data, null);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(async function (response: any) {            
            if((response.data.data.errors && response.data.data.errors.length > 0)){
              return reject(new Error(response.data.data.errors));
            }
            else{
                let resolvedResponse = response.data.data.calculatorService;
                return resolve(resolvedResponse)
            }
          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.calcResultError);
            return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

export const getWeatherRelatedNFDRSCall = async(request: any, addAlert:any,) => {
  try {
    let data = JSON.stringify({
      query: getWeatherRelatedNFDRSQuery,
      variables: {
        stationId: request.stationId,
        dateTimeFormat: request.dateTimeFormat,
        startDate: request.startDate,
        endDate: request.endDate,
        startHour: request.startHour,
        endHour: request.endHour,
        fuelModel: request.fuelModel,
      }
    });
    let config = configMutationClimatology(data, null);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(async function (response: any) {            
            if((response.data.data.errors && response.data.data.errors.length > 0)){
              return reject(new Error(response.data.data.errors));
            }
            else{
                let resolvedResponse = response.data.data.getWeatherRelatedNFDRS;
                return resolve(resolvedResponse)
            }
          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.calcResultError);
            return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};